export default __webpack_public_path__ + "static/Search-dbe8954b93fd71242b53c01fd8534380.mp4";